import axios from "axios";
// import router from "@/router";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + "/api",
  timeout: 5000,
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status && res.status != 200) {
      return Promise.reject(res.msg);
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error);
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000,
    // });
    return Promise.reject(error);
  }
);

export default service;
